// Centralized backend URL configuration
export const BACKEND_BASE = "https://api.gowithmebuddy.com";
export const API_BASE_URL = `${BACKEND_BASE}/api`;
//Use local backend by default in development. No leading spaces to avoid malformed URLs.
// export const BACKEND_BASE = "http://127.0.0.1:8000";
// export const API_BASE_URL = `${BACKEND_BASE}/api`;
